import { useCallback } from 'react'

const intlInstance = new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 })

/**
 * @ param decimals The number of decimals to display
 * @returns A function that formats the PEPPER value
 */
export const useCurrencyFormatter = (decimals: number = 0) => {
	return useCallback<(amount: bigint | string | number) => string>(
		amount => {
			const intlInstance = new Intl.NumberFormat(navigator.language, {
				maximumFractionDigits: decimals
			})

			return intlInstance.format(Number(amount))
		},
		[decimals]
	)
}
